import React from 'react';
import './ProcessingStatus.css';

interface ProcessingStatusProps {
  progress: number;
  stage: string;
}

const ProcessingStatus: React.FC<ProcessingStatusProps> = ({ progress, stage }) => {
  return (
    <div className="processing-container">
      <div className="processing-card">
        <div className="processing-spinner">
          <div className="spinner"></div>
        </div>
        
        <h2>Processing Videos</h2>
        <p className="processing-stage">{stage}</p>
        
        <div className="progress-bar">
          <div 
            className="progress-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        
        <p className="progress-text">{progress}% complete</p>
        
        <div className="processing-info">
          <p>This may take 2-5 minutes depending on video length...</p>
          <p className="processing-note">Please keep this window open</p>
        </div>
      </div>
    </div>
  );
};

export default ProcessingStatus;
